/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../../utils/config';

export const CPU_UTILIZATION_URL = `${API_URL}/fibersites/cpu`;
